module.exports = __webpack_public_path__ + "img/servier_china.b6b4a597.png";